export default function experiments(state = {}) {
  return state;
}
